import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { GoogleMap, MapMarker, MapInfoWindow } from '@angular/google-maps';
import { LibTableComponent } from 'tuain-ng-forms-lib';
// import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';

@Component({
  selector: 'app-map-table',
  templateUrl: './app-map-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AppMapTableComponent extends LibTableComponent {
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

  zoom = 8;
  lat = -1.212457;
  long = -78.318120;

  markers: any[];
  infoContent: {};

  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  };

  markerOptions: any = { animation: google.maps.Animation.BOUNCE };

  override ngOnInit() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });
    this.addMarker();
  }

  addMarker() {
    this.markers.push({
      position: {
        lat: this.center.lat + ((Math.random() - 0.5) * 2) / 10,
        lng: this.center.lng + ((Math.random() - 0.5) * 2) / 10,
      },
      label: {
        color: 'red',
        text: 'Marker label ' + (this.markers.length + 1),
      },
      title: 'Marker title ' + (this.markers.length + 1),
      options: { animation: google.maps.Animation.BOUNCE },
    });
  }

  zoomIn() {
    if (this.zoom < this.options.maxZoom) this.zoom++;
  }

  zoomOut() {
    if (this.zoom > this.options.minZoom) this.zoom--;
  }

  logCenter() {
    console.log(JSON.stringify(this.map.getCenter()));
  }

  // clickOnMap(event) {
  //   if (!this.editable) { return; }
  //   this.value = [event.coords.lat, event.coords.lng];
  //   this.updateObject();
  //   this.onChangeContent();
  // }

  openInfo(marker: MapMarker, content) {
    this.infoContent = content;
    this.infoWindow.open(marker);
  }
}
